import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ICompanySetting, ISetting } from '../settings.interface';
import { SettingsService } from '../settings.service';
import * as _ from 'lodash';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-settings-company-modal',
  templateUrl: './settings-company-modal.component.html',
  styleUrls: ['./settings-company-modal.component.css']
})
export class SettingsCompanyModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  setting!: ISetting;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;

  constructor(
    public _SettingsService: SettingsService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    this.buildForm();
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      name: [this.setting.name, [Validators.required]],
      value: [_.get(this.setting, 'companySetting.value', this.setting.defaultValue), [Validators.required]],
      isDeleted: [this.setting.isDeleted]
    });
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let formData: any = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;

    const data: ICompanySetting = {
      _id: _.get(this.setting, 'companySetting._id'),
      company: _.get(this.setting, 'companySetting.company', this._AuthService.companyId()),
      setting: _.get(this.setting, 'companySetting.setting', this.setting._id),
    };
    data.value = formData.value;
    this.saving = true;
    this._SettingsService.setCompanySetting(data)
      .subscribe((setting: any) => {
        this.dialog.close(setting);
      });
  }
}